/**
 * SCALE LAYER — single source for all pixel values, derived from viewport.
 */
import * as C from "../config/constants.js";

var BASE_DIVISOR = 50;
var PLAYER_VISUAL_RADIUS_RATIO = 1.0;
var OBJECT_HEIGHT_RATIO = 2.4;
var GEM_SIZE_RATIO = 1.6;
var FLASK_DISPLAY_WIDTH_RATIO = 4.2;
var FLASK_MARGIN_RATIO = 0.5;
var FLASK_TOP_RATIO = 1.8;
var FLASK_BOTTOM_OFFSET_RATIO = 1.0;
var FLASK_WALL_THICKNESS_RATIO = 1.8;
var MERGE_PICKUP_RADIUS_RATIO = 0.56;
var MERGE_FLASH_RADIUS_RATIO = 1.0;
var GEM_SPACING_RATIO = 0.8;
var PICKUP_MARGIN_RATIO = 0.8;
var PICKUP_OFFSET_RATIO = 3.2;

var BODY_RADIUS_RATIOS = [0.24, 0.32, 0.4, 0.48, 0.56, 0.64, 0.72, 0.8, 0.88, 0.96, 1.04, 1.12, 1.2, 1.28, 1.36];

export function getScale(w, h) {
  var baseUnit = Math.min(w, h) / BASE_DIVISOR;
  if (baseUnit <= 0) baseUnit = 12;

  var flaskScale = C.FLASK_MERGE_SCALE != null ? C.FLASK_MERGE_SCALE : 1.0;
  var runwayScale = C.RUNWAY_MERGE_PICKUP_SCALE != null ? C.RUNWAY_MERGE_PICKUP_SCALE : 1.0;
  var runwayFlaskWidthScale = C.RUNWAY_FLASK_WIDTH_SCALE != null ? C.RUNWAY_FLASK_WIDTH_SCALE : 1.0;
  var runwayFlaskSizeScale = C.RUNWAY_FLASK_SIZE_SCALE != null ? C.RUNWAY_FLASK_SIZE_SCALE : 1.0;

  var neckOpeningRatio = C.FLASK_NECK_OPENING_RATIO != null ? C.FLASK_NECK_OPENING_RATIO : 0.67;
  var neckRimOffsetRatio = C.FLASK_NECK_RIM_OFFSET_Y_RATIO != null ? C.FLASK_NECK_RIM_OFFSET_Y_RATIO : 0.02;
  var flaskAspect = C.FLASK_IMAGE_ASPECT_RATIO != null ? C.FLASK_IMAGE_ASPECT_RATIO : 1.0;

  var runwayFlaskDisplayWidth = Math.max(
    1,
    baseUnit * FLASK_DISPLAY_WIDTH_RATIO * runwayFlaskWidthScale
  );
  var runwayFlaskDisplayHeight = runwayFlaskDisplayWidth * flaskAspect;
  var flaskMouthWidth = runwayFlaskDisplayWidth * neckOpeningRatio;
  var flaskMouthOffsetY = -runwayFlaskDisplayHeight * (1 - neckRimOffsetRatio);

  var bodyRadiusByTier = BODY_RADIUS_RATIOS.map(function (r) { return Math.max(4, baseUnit * r * flaskScale); });

  return {
    baseUnit: baseUnit,
    playerVisualRadius: Math.max(8, baseUnit * PLAYER_VISUAL_RADIUS_RATIO * runwayFlaskSizeScale),
    objectHeight: Math.max(20, baseUnit * OBJECT_HEIGHT_RATIO),
    gemSize: Math.max(8, baseUnit * GEM_SIZE_RATIO),
    gemSpacing: Math.max(4, baseUnit * GEM_SPACING_RATIO),
    runwayFlaskDisplayWidth: runwayFlaskDisplayWidth,
    runwayFlaskDisplayHeight: runwayFlaskDisplayHeight,
    flaskMouthOffsetY: flaskMouthOffsetY,
    flaskMouthWidth: flaskMouthWidth,
    flaskMargin: Math.max(8, baseUnit * FLASK_MARGIN_RATIO),
    flaskTop: Math.max(40, baseUnit * FLASK_TOP_RATIO),
    flaskBottomOffset: Math.max(20, baseUnit * FLASK_BOTTOM_OFFSET_RATIO),
    flaskWallThickness: Math.max(20, baseUnit * FLASK_WALL_THICKNESS_RATIO),
    mergePickupRadius: Math.max(8, baseUnit * MERGE_PICKUP_RADIUS_RATIO * runwayScale),
    mergeFlashRadius: Math.max(12, baseUnit * MERGE_FLASH_RADIUS_RATIO),
    pickupMargin: Math.max(10, baseUnit * PICKUP_MARGIN_RATIO),
    pickupOffset: Math.max(40, baseUnit * PICKUP_OFFSET_RATIO),
    bodyRadiusByTier: bodyRadiusByTier,
  };
}
